const tpl = (name) => `OKVEDS/${name}`;

export const GET_OKVEDS = tpl`GET_OKVEDS_REQUEST`;
export const GET_OKVEDS_SUCCESS = tpl`GET_OKVEDS_SUCCESS`;
export const GET_OKVEDS_FAILURE = tpl`GET_OKVEDS_FAILURE`;

export const GET_POPULAR_OKVEDS = tpl`GET_POPULAR_OKVEDS`;
export const GET_POPULAR_OKVEDS_SUCCESS = tpl`GET_POPULAR_OKVEDS_SUCCESS`;
export const GET_POPULAR_OKVEDS_FAILURE = tpl`GET_POPULAR_OKVEDS_FAILURE`;
